/* Monde Singulier: prix dans la devise locale.
   Sélecteur pays / devise du footer, et à la première visite, bascule sur le pays détecté par Shopify (IP). */
(() => {
  const f = document.getElementById('loc-form');
  if (!f) return;
  const cc = f.querySelector('[name=country_code]');
  if (!cc) return;
  const st = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  const go = (c) => { if (!c) return; cc.value = c; st.set('ms_geo', c); f.submit(); };
  document.querySelectorAll('[data-country]').forEach((s) => s.addEventListener('change', () => go(s.value)));

  const S = window.Shopify || {};
  if (S.designMode || st.get('ms_geo')) return;
  if (/bot|crawl|spider|slurp|lighthouse|headless/i.test(navigator.userAgent)) return;
  const cur = S.country || cc.value || '';
  st.set('ms_geo', cur || '1');
  const root = (S.routes && S.routes.root) || '/';
  fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' + encodeURIComponent(cur))
    .then((r) => r.json())
    .then((j) => {
      const s = j && j.suggestions && j.suggestions[0];
      const c = s && s.parts && s.parts.country && s.parts.country.handle;
      if (c && c !== cur) go(c);
    })
    .catch(() => {});
})();